const Konfetti2 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={555}
    height={168}
    fill="none"
    {...props}
  >
    <path fill="#FEF200" d="m547 71 5 13 23-1-5-12h-23Z" />
    <path fill="#ADDDE4" d="m449 23 5 11 20-2-4-10-21 1Z" />
    <path fill="#FEF200" d="m373 120 11 2 8-15-9-3-10 16Z" />
    <path fill="#FEF200" d="M460 141v-12l-19-6v11l19 7Z" />
    <path fill="#fff" d="m143 114-5-13-12 6 3 12 14-5Z" />
    <path fill="#FEF200" d="m261 53-19 1 17 11 2-12Z" />
    <path fill="#ADDDE4" d="m181 40-11 16 19-7-8-9Z" />
    <path fill="#ADDDE4" d="m336 110-13-1-9 18 11 2 11-19Z" />

    <path
      fill="#FEF200"
      d="m530 155-11-8 28-22 8 5-25 25Zm-284-13 1 10 16 3-1-9-16-4Zm113-73 9 10 20-8-8-10-21 8Z"
    />
    <path fill="#ADDDE4" d="m79 129 9 3 15-34-8-4-16 35Z" />
    <path fill="#0397D8" d="M86 122v-13l-19-6-1 11 20 8Z" />
  </svg>
);
export default Konfetti2;
